
const getGeoJson = ( objs ) => {
	let features = [];
	objs.forEach( function(obj) {
		let item = {
			'title': obj.title,
			'address': 'none',
			'price': obj.price,
			'beds': obj.beds,
			'baths': obj.baths,
			'latitude': obj.latitude,
			'longitude': obj.longitude,
			'permalink': obj.permalink,
			'pets': 'none'
		}
		features.push(item);
	});
	return features;
}


export default function ( data ) {
	let layers;
	Window.overlays.clearLayers();
  var clusterGroup = new L.MarkerClusterGroup().addTo(Window.overlays);
	let addressPoints = getGeoJson(data);
	for (let i = 0; i < addressPoints.length; i++) {
    let a = addressPoints[i];
    let title = a.title + '<br>';
		let info = a.beds + ' bed: $' + a.price + '<br>';
		let link = '<a href="' + a.permalink + '">View Property</a>';
		let marker = L.marker(new L.LatLng(a.latitude, a.longitude), {
			 icon: L.divIcon({
					className: 'map-marker',
					iconSize: [40, 40],
					title: a.title,
					html: '<span class="map-marker-icon"></span>'
				}),
		 title: a.title,
		 link: link
		});
		marker.bindPopup(title + info + link);
		clusterGroup.addLayer(marker);
  }
}
